import { z } from "zod";

export const ChartType = {
	BAR: "bar",
	LINE: "line",
	PIE: "pie",
	SCATTER: "scatter",
	AREA: "area",
	COMPOSED: "composed",
	TABLE: "table",
} as const;

export type ChartType = (typeof ChartType)[keyof typeof ChartType];

export const CHART_TYPES = Object.values(ChartType) as readonly ChartType[];

export const chartTypeSchema = z.enum(ChartType);
